<div class="modal-overlay" @modalPop>
    <div class="modal modal--w640">
        <div class="modal__header modal__header--row">
            <div>
                <h3 class="modal__title">Welcome to Sapphire AVS!</h3>
                <div class="modal__description">We're excited to help you audit your address data and secure corrected addresses.</div>
            </div>
            <button class="icon-btn" type="button" (click)="onClose()">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><use href="#icon-close"></use></svg>
            </button>
        </div>

        <div class="modal__body modal__body--scroll">
            <div class="onboarding-step">
                <img class="onboarding-step__icon" src="../../../assets/images/icon_address_book.png" alt="" />
                <div>
                    <div class="drawer__step-title">1. Sync your address book</div>
                    <div class="drawer__step-text">
                        Upload a
                        <button class="link-accent" (click)="downloadCSVTemplate()">CSV file using our template</button>
                        or connect your Salesforce account directly from your Settings.
                    </div>
                    <div class="drawer__step-text">
                        Need a custom integration? Email us at
                        <a href="mailto:team@sapphiredc.com" class="onboarding-step__contact-link">team&#64;sapphiredc.com</a>
                        - we're happy to assist.
                    </div>
                </div>
            </div>

            <div class="onboarding-step">
                <img class="onboarding-step__icon" src="../../../assets/images/icon_payment_method.png" alt="" />
                <div>
                    <div class="drawer__step-title">2. Add a payment method</div>
                    <div class="drawer__step-text">Go to Settings &rarr; Payments and securely add your preferred payment method.</div>
                </div>
            </div>

            <div class="onboarding-step">
                <img class="onboarding-step__icon" src="../../../assets/images/icon_upload.png" alt="" />
                <div>
                    <div class="drawer__step-title">3. Start correcting addresses</div>
                    <div class="drawer__step-text">Correct addresses directly or upload returned envelopes to get updated addresses.</div>
                </div>
            </div>
        </div>

        <div class="modal__footer">
            <button type="button" class="btn btn--primary" (click)="onClose()">Got it!</button>
        </div>
    </div>
</div>

@if (loading) {
    <app-loader></app-loader>
}
